//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import { List } from 'react-virtualized';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';
import { ButtonTypes } from 'common/components/core/button/Button';
import ButtonWithPopover from 'common/components/core/button/ButtonWithPopover';
import theme from './ButtonWithPopoverList.scss';

const ButtonWithPopoverList = ({
    theme,
    listOptions,
    listOptionRenderer,
    listRowHeight = 25,
    listWidth = 150,
    listHeight = 150,
    icon = 'filter',
    buttonType = ButtonTypes.Icon,
    popOverClassName,
    triggerPopoverOn = PopoverTriggerEnum.Click,
    invertPopover = false,
    className,
    listRef,
    selectedValues,
    ...others
}) => {
    return (
        <ButtonWithPopover
            {...others}
            className={classnames(className, theme.popoverButton)}
            theme={theme}
            buttonType={buttonType}
            icon={icon}
            popOverClassName={classnames(
                popOverClassName,
                theme.buttonPopoverWithList
            )}
            popOverContent={
                <ListOptions
                    theme={theme}
                    options={listOptions}
                    optionRenderer={listOptionRenderer}
                    listRowHeight={listRowHeight}
                    listHeight={listHeight}
                    listWidth={listWidth}
                    listRef={listRef}
                    selectedValues={selectedValues}
                />
            }
            triggerPopoverOn={triggerPopoverOn}
            invertPopover={invertPopover}
        />
    );
};

class ListOptions extends React.PureComponent {
    render() {
        const {
            options,
            optionRenderer,
            listRowHeight,
            listHeight,
            listWidth,
            listRef,
            selectedValues
        } = this.props;
        return (
            <List
                listRef={listRef}
                width={listWidth}
                rowHeight={listRowHeight}
                height={listHeight}
                rowCount={options.length}
                rowRenderer={optionRenderer}
                selectedValues={selectedValues}
            />
        );
    }
}

const ThemedButtonWithPopoverList = themr(
    'ButtonWithPopoverList',
    theme
)(ButtonWithPopoverList);
export default ButtonWithPopoverList;
export { ThemedButtonWithPopoverList as ButtonWithPopoverList };
